import { ChannelMemberSuggestResponse } from '@src/api/shared/community/channelMemberApiClient';
import { createContext, ReactNode, useContext, useState } from 'react';

type UnsavedInviteUsersContextType = {
  unsavedInviteUsers: ChannelMemberSuggestResponse;
  setUnsavedInviteUsers: (users: ChannelMemberSuggestResponse) => void;
};

const UnsavedInviteUsersContext = createContext<UnsavedInviteUsersContextType | undefined>(
  undefined,
);

export const UnsavedInviteUsersProvider = ({ children }: { children: ReactNode }) => {
  const [unsavedInviteUsers, setUnsavedInviteUsers] = useState<ChannelMemberSuggestResponse>([]);

  return (
    <UnsavedInviteUsersContext.Provider value={{ unsavedInviteUsers, setUnsavedInviteUsers }}>
      {children}
    </UnsavedInviteUsersContext.Provider>
  );
};

export const useUnsavedInviteUsers = () => {
  const context = useContext(UnsavedInviteUsersContext);
  if (!context) {
    throw new Error('useUnsavedInviteUsers must be used within an UnsavedInviteUsersProvider');
  }
  return context;
};
